import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IForgotEmailPayload } from '../../../../features/auth/@core/interfaces/forgot-email.interface';
import { IRegisterPayload } from '../../../../features/auth/@core/interfaces/register.interface';
import { IResetPasswordPayload } from '../../../../features/auth/@core/interfaces/reset-password.interface';
import { INewAccessTokenPayload, INewAccessTokenResponseDTO } from '../../../interfaces';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root',
})
export class AdminAccountController {
  private readonly _path = '/admin/account';

  constructor(private readonly apiService: ApiService) {}

  register(payload: IRegisterPayload): Observable<void> {
    return this.apiService.post(`${this._path}/register`, payload);
  }

  logout(): Observable<void> {
    return this.apiService.post(`${this._path}/logout`);
  }

  resetPassword(payload: IResetPasswordPayload): Observable<void> {
    return this.apiService.post(`${this._path}/reset-password`, payload);
  }

  forgotPassword(email: IForgotEmailPayload): Observable<void> {
    return this.apiService.post(`${this._path}/forgot-password`, email);
  }

  getNewAccessToken(token: INewAccessTokenPayload): Observable<INewAccessTokenResponseDTO> {
    return this.apiService.put(`${this._path}/refresh-token`, token);
  }
}
